import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import moment from "moment";
import * as FaIcons from "react-icons/fa";

const RegistrationFormRow = ({
  info: {
    _id,
    createdAt,
    status,
    registerForIntercession,
    age,
    firstName,
    lastName,
    pgRelationshipToStudent,
    pgFirstName,
    pgLastName,
    studentEmail,
    studentPrimaryPhone,
    learningCenterName,
    programs,
  },
  visibleColumns,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { ageOver } = adminRegistrationContext;

  // Helper function to check if column is visible
  const isColumnVisible = (columnName) => {
    if (!visibleColumns) return true; // Show all if no visibility settings
    return visibleColumns[columnName] !== false;
  };

  return (
    <tr
      onClick={() => {
        navigate(`/registration-forms/${_id}`, {
          state: { from: location.pathname },
        });
      }}
    >
      {isColumnVisible("createdAt") && <td>{moment(createdAt).format("MM/DD/YYYY")}</td>}
      {isColumnVisible("status") && <td>{status}</td>}
      {isColumnVisible("learningCenterName") && <td>{learningCenterName}</td>}
      {isColumnVisible("enrollmentType") && <td>{registerForIntercession ? "Intersession " : "Regular"}</td>}
      {isColumnVisible("studentFirstName") && <td>{`${firstName} ${lastName}`}</td>}
      {isColumnVisible("age") && <td>{age}</td>}
      {isColumnVisible("phone") && <td>{studentPrimaryPhone}</td>}
      {isColumnVisible("primaryEmail") && <td>{studentEmail}</td>}
    </tr>
  );
};

export default RegistrationFormRow;
